export const keyCombo = (pattern) => {
    const {masks, key} = parsePattern(pattern);

    const mask = masks.reduce((r, m) => ({...r, [m]: true}), {
        shift: false,
        alt:   false,
        meta:  false,
        ctrl:  false,
    });

    // console.log({masks, key})
    return (e) => {
        // console.log(e.key)
        // console.log(mask, key);
        if (Object.keys(mask).find((attr) => e[attr+"Key"] != mask[attr])) {
            return false;
        }
        return key === e.key.toLowerCase();
    }
};

const parsePattern = (pattern) => {
    pattern = pattern.toLowerCase();
    const match = /(\^|ctrl\+|shift\+|alt\+|meta\+)(.+)/.exec(pattern);
    if (match) {
        const next = parsePattern(match[2]);
        return {
            masks: [masks[match[1]], ...next.masks],
            key: next.key,
        };
    } else {
        return {masks: [], key: pattern.toLowerCase()};
    }
};

const masks = {
    "^": "ctrl",
    "ctrl+": "ctrl",
    "shift+": "shift",
    "alt+": "alt",
    "meta+": "meta",
};